import { type SVGProps } from 'react';

import { cn } from '@shared/utils';

export interface LogoutIconProps extends SVGProps<SVGSVGElement> {
  className?: string;
}

export function LogoutIcon({ className, ...props }: Readonly<LogoutIconProps>) {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={cn('text-[#D5D7DA]', className)}
      aria-hidden="true"
      {...props}
    >
      <path
        d="M15.75 9V5.25C15.75 4.00736 14.7426 3 13.5 3L7.5 3C6.25736 3 5.25 4.00736 5.25 5.25L5.25 18.75C5.25 19.9926 6.25736 21 7.5 21H13.5C14.7426 21 15.75 19.9926 15.75 18.75V15M18.75 9L21.75 12L18.75 15M21.75 12L9 12"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
